import { FaCog } from "react-icons/fa";
import "../styles/KeyTakeawayImageWithPlaceholder.scss";
import {useEffect} from "react";
import Image from "react-bootstrap/Image";

const KeyTakeawayImageWithPlaceholder = ({ image }) => {
    useEffect(() => {
        console.log('Image placeholder:', image);
    }, []);
    if (image?.image_url) {
        return (
            <img
                src={image.image_url}
                alt="Key takeaway"
                className="kt-image"
            />
        );
    }

    return (
        <div className="kt-placeholder-">
            {/*<img*/}
            {/*    src="/img/podsy-image-placeholder-bg.jpg"*/}
            {/*    alt="Placeholder"*/}
            {/*    className="kt-image"*/}
            {/*/>*/}
            {/*<FaCog className="kt-cog" />*/}
            <Image src={'/img/podsy-loader.gif'} fluid />
        </div>
    );
};

export default KeyTakeawayImageWithPlaceholder;
